import { InjectionToken } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';

export type CapacitorPlatform = 'ios' | 'android' | 'web';
export type CapacitorPauseResumeType = 'native' | 'web';

export const APP_UPDATE_DIALOG_COMPONENT_TYPE: InjectionToken<ComponentType<unknown>>
  = new InjectionToken<ComponentType<unknown>>('App update component constructor');
